<template>
  <span>
  <a @click="togglePerson"
     :title="object.blocked == 0 ? $t('block') : $t('activate')"
     v-b-tooltip.hover
     class="data-table-action">
    <BlockSvg v-if="object.blocked == 0"/>
    <ActivateSvg class="svg-light" v-if="object.blocked == 1"/>
    <span class="action-button-mob-title">{{ object.blocked == 0 ? $t('block') : $t('activate') }}</span>
  </a>
    </span>
</template>

<script setup>
import BlockSvg from '@/assets/svg-vue/general/block.svg'
import ActivateSvg from '@/assets/svg-vue/form/tick.svg'
import { EloquentService } from "@/services/api/eloquent.api.service"
import { doctorAdapter } from '@/adapters/staff/doctor'
import { useStore} from "vuex"
import {appendFormdata} from "@/extensions/prototypes/prototypes"

const props = defineProps({
  object: {
    type: Object
  }
})

const store = useStore()

const togglePerson = () => {
  let data = doctorAdapter(props.object)
  delete data.full
  data.blocked = Number(props.object?.blocked) === 1 ? 0 : 1
  const formData = appendFormdata(new FormData(), data)
  EloquentService.update('curator', props.object.id, formData).then(() => {
    store.commit('incrementDataTableCounter')
  })
}
</script>
